"use strict";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import Account from "../../api/account";
import AutoConfirmedLoadHeader from "../auto_confirmed_load_header";
import InvoiceInputFieldsOwnerMixin from "./invoice_input_fields_owner_mixin";
import LoadAssignerProgress, {
  getLoadAssignerProgressItems
} from "./load_assigner_progress";
import LoadTable from "./load_table";
import LoadSearchArea from "./load_search_area";
import DocumentExceptionArea from "./document_exception_area";
import CarrierChooser from "./carrier_chooser";
import CarrierInvoiceChooser from "./carrier_invoice_chooser";
import DocumentTitle from "react-document-title";
import DisablingButton from "../../components/disabling_button";
import reactUtils from "../../react_utils";
var bem = reactUtils.makeBem("document-group-editor");
function hasGuessedLoadFor(props) {
  return props.loads.guessed.length > 0 || props.loads.selected;
}
function createLoadsInHubtran() {
  return Account.currentSettings().create_loads_in_hubtran;
}
function creatingLoad(isNew) {
  return isNew === true && createLoadsInHubtran();
}
function possibleCarrierChooserNumbering() {
  if (!createLoadsInHubtran()) {
    return /* @__PURE__ */ React.createElement("span", { className: "paragraph__possible-select-load-text-numbering" }, /* @__PURE__ */ React.createElement("strong", null, "2."));
  }
}
export default React.createClass({
  // eslint-disable-line no-restricted-syntax -- Legacy React.createClass - to be migrated
  mixins: [InvoiceInputFieldsOwnerMixin],
  newInvoice: { id: "new" },
  getInitialState: function() {
    const hasGuessedLoad = hasGuessedLoadFor(this.props);
    return {
      showExceptions: _.first(this.activeExceptions()),
      showSearch: !hasGuessedLoad,
      showGuessed: hasGuessedLoad,
      source_invoice_amount: null,
      source_invoice_number: null
    };
  },
  componentDidMount: function() {
    if (hasGuessedLoadFor(this.props)) {
      this.focusNextField();
    }
  },
  componentWillReceiveProps: function(nextProps) {
    if (this.props.group !== nextProps.group) {
      const hasGuessedLoad = hasGuessedLoadFor(nextProps);
      this.setState({
        showExceptions: _.first(this.activeExceptions(nextProps)),
        showSearch: !hasGuessedLoad,
        showGuessed: hasGuessedLoad
      });
    }
    if (nextProps.saving !== this.props.saving) {
      this.setState({ saving: nextProps.saving });
    }
  },
  // STATE
  assignLoad: function(isNew) {
    let selectedLoad;
    if (creatingLoad(isNew)) {
      selectedLoad = "new";
    } else {
      selectedLoad = this.props.loads.selected;
    }
    var isFirstLoad = !this.props.currentlyAssignedInvoiceForGroup;
    const carrierInvoice = {};
    ["source_invoice_number", "source_invoice_amount"].forEach((field) => {
      if (this.state[field]) {
        carrierInvoice[field] = this.state[field];
      }
    });
    const assignCustomerOnlyDocuments = this.props.assignCustomerOnlyDocuments;
    this.setState({ saving: true });
    const carrierID = this.carrierID(isNew);
    this.props.assignCurrentGroupToLoadAndInvoiceId(
      selectedLoad,
      this.props.getSelectedInvoiceForGroup(this.newInvoice).id,
      carrierInvoice,
      carrierID,
      isFirstLoad,
      assignCustomerOnlyDocuments,
      this.props.shipmentDocumentSelections
    );
  },
  carrierID: function(isNew) {
    if (creatingLoad(isNew)) {
      return this.props.selectedCarrierID || this.props.documentBatch.single_carrier && this.props.documentBatch.carrier_id || null;
    } else {
      return this.props.selectedCarrierID;
    }
  },
  toggleExceptions: function() {
    this.setState({ showExceptions: !this.state.showExceptions });
  },
  showSearch: function() {
    this.setState({ showSearch: true });
  },
  cancelSearch: function() {
    this.setState({ showSearch: false });
    this.focusNextField();
  },
  carrierSelected: function(carrier) {
    this.setState({ carrier });
  },
  // RENDER
  render: function() {
    return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "TriumphPay Audit \u2013 Assign Loads" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__root" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__scrollable-area" }, this.reportProblemContent(), this.assignLoadsContent()), this.progressArea()));
  },
  showAssignLoadsContent: function() {
    return (!this.state.showExceptions || this.state.showExceptions && this.activeExceptions().length > 0) && !this.state.recentlyResolved;
  },
  assignLoadsContent: function() {
    if (this.showAssignLoadsContent()) {
      return /* @__PURE__ */ React.createElement("div", null, this.assignLoadsHeader(), this.selectLoadText(), this.documentGroup(), this.possibleExceptionsLink());
    }
  },
  assignLoadsHeader: function() {
    var selectedLoad = this.props.loads.selectedLoad;
    var text = "Assign Load to This Document Group";
    if (selectedLoad && !selectedLoad.load.load_is_auto_confirmed) {
      return /* @__PURE__ */ React.createElement("h3", null, text);
    } else if (!selectedLoad) {
      return /* @__PURE__ */ React.createElement("h3", null, text);
    }
  },
  documentGroup: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__group") }, /* @__PURE__ */ React.createElement("div", { className: bem("__group-title") }, this.props.group.name), this.possibleNonMatchingCarrierWarning(), this.loadSearchArea(), this.guessedLoadsContent());
  },
  possibleExceptionsLink: function() {
    if (!this.state.showExceptions) {
      return /* @__PURE__ */ React.createElement("p", { className: "load-assigner__report-problem" }, "Still issues?", " ", /* @__PURE__ */ React.createElement("a", { onClick: this.toggleExceptions }, "Create an exception"));
    }
  },
  userCreatedLoadExists: function() {
    return !!_.findWhere(
      _.map(this.props.loads.guessed, (load) => load.load),
      { source_system: "hubtran" }
    );
  },
  guessedLoads: function() {
    return _.reject(this.props.loads.guessed, (load) => {
      return load.load.source_system == "hubtran";
    });
  },
  possibleSelectLoadTextNumbering: function() {
    if (this.props.multiCarrier) {
      return /* @__PURE__ */ React.createElement("span", { className: "paragraph__possible-select-load-text-numbering" }, /* @__PURE__ */ React.createElement("strong", null, "1."));
    }
  },
  selectLoadText: function() {
    if (!this.state.showSearch) {
      var selectedLoad = this.props.loads.selectedLoad;
      var text = selectedLoad && selectedLoad.load.load_is_auto_confirmed ? this.autoConfirmedLoadHeader() : "Select a load from the loads we identified in the documents. ";
      return /* @__PURE__ */ React.createElement("div", { className: "paragraph" }, /* @__PURE__ */ React.createElement("span", null, this.possibleSelectLoadTextNumbering(), text, "Not the right ones?", " ", /* @__PURE__ */ React.createElement("a", { onClick: this.showSearch }, "Search for another one"), "."));
    }
  },
  autoConfirmedLoadHeader: function() {
    return /* @__PURE__ */ React.createElement(
      AutoConfirmedLoadHeader,
      {
        carrierInvoice: null,
        load: this.props.loads.selectedLoad
      }
    );
  },
  loadsNotFromEmailCarrier: function(loadState) {
    return this.props.email.carrier_id && loadState.load.carrier_id !== this.props.email.carrier_id;
  },
  possibleNonMatchingCarrierWarning: function() {
    if (!this.state.showSearch && _.find(this.guessedLoads(), this.loadsNotFromEmailCarrier)) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, /* @__PURE__ */ React.createElement("span", null, "At least one of the following loads is assigned to a", " ", Account.carrierTermLower(), " that does not match the", " ", Account.carrierTermLower(), " assigned to this email."));
    }
  },
  progressArea: function() {
    if (this.state.tab !== "exception") {
      return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__save-buttons" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__save-buttons-inner" }, this.invoiceInputFields(), this.carrierChooser(), this.invoiceChooser(), this.possibleCreateLoadButton(), this.possibleMessageOrSave()));
    }
  },
  carrierChooser: function() {
    if ((this.props.loads.selected || createLoadsInHubtran()) && !this.props.documentBatch.single_carrier) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__carrier-chooser" }, this.possibleMultipleGuessedCarriersNotification(), /* @__PURE__ */ React.createElement("h6", null, possibleCarrierChooserNumbering(), "Select a ", Account.carrierTermLower(), " for this invoice:"), /* @__PURE__ */ React.createElement(
        CarrierChooser,
        {
          carrierGuesses: this.props.carrierGuesses(),
          allowIndexingCustomerOnlyDocuments: this.isIndexCustomerOnlyDocsEnabled(),
          state: this.props.carrierChooserState,
          onUpdate: this.props.onCarrierChooserUpdate
        }
      ));
    }
  },
  selectedLoadIsUserCreated: function() {
    var selectedLoad = this.props.loads.selectedLoad;
    return !_.isEmpty(selectedLoad) && selectedLoad.load.source_system === "hubtran";
  },
  nonUserCreatedLoadSelected: function() {
    return this.props.loads.selected && !this.selectedLoadIsUserCreated();
  },
  invoiceChooser: function() {
    if (this.nonUserCreatedLoadSelected() && this.props.selectedCarrierID || this.showInvoiceChooserForCustomerOnlyDocs()) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        CarrierInvoiceChooser,
        {
          loadID: this.props.loads.selectedLoad.load.load_id,
          invoicesForGroup: this.props.invoicesForGroup,
          initialInvoiceId: _.first(
            _.compact(
              _.pluck(this.props.group.documents, "carrier_invoice_id")
            )
          ),
          selectedInvoice: this.props.getSelectedInvoiceForGroup(
            this.newInvoice
          ),
          carrierID: this.props.selectedCarrierID,
          group: this.props.group,
          newInvoice: this.newInvoice,
          currentlyAssignedInvoice: this.props.currentlyAssignedInvoiceForGroup,
          invoiceSelected: this.props.setSelectedInvoiceForGroup
        }
      ));
    }
  },
  possibleCreateLoadButton: function() {
    if (createLoadsInHubtran() && !this.nonUserCreatedLoadSelected()) {
      if (!this.props.selectedCarrierID) {
        return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__possible-create-load-button" }, /* @__PURE__ */ React.createElement("button", { className: "button--disabled", disabled: true }, "Select a ", Account.carrierTermLower(), " to continue"));
      }
      if (this.userCreatedLoadExists()) {
        var buttonText = "Edit Existing Created Load";
      } else {
        var buttonText = "Create a Load";
      }
      return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__possible-create-load-button" }, /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabledText: buttonText,
          className: "button--progress",
          disabled: this.state.saving,
          onClick: _.partial(this.assignLoad, true)
        },
        buttonText
      ));
    }
  },
  possibleMessageOrSave() {
    if (!createLoadsInHubtran() || this.nonUserCreatedLoadSelected()) {
      return this.messageOrSave();
    }
  },
  messageOrSave: function() {
    let button;
    if (this.state.saving) {
      button = /* @__PURE__ */ React.createElement("button", { disabled: true }, "Saving...");
    } else if (this.props.loads.selected && this.props.selectedCarrierID && this.props.getSelectedInvoiceForGroup(this.newInvoice)) {
      let buttonText = "Continue";
      if (Account.indexAuditSplitEnabled()) {
        buttonText = "Submit";
      }
      button = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "button--progress ", onClick: this.assignLoad }, buttonText));
    } else if (this.props.loads.selected && this.props.assignCustomerOnlyDocuments && this.isIndexCustomerOnlyDocsEnabled()) {
      let buttonText = "Continue assigning customer only documents";
      if (Account.indexAuditSplitEnabled()) {
        buttonText = "Submit customer only documents";
      }
      button = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "button--progress ", onClick: this.assignLoad }, buttonText));
    } else if (this.props.loads.selected && this.props.selectedCarrierID) {
      button = /* @__PURE__ */ React.createElement("button", { className: "button--disabled", disabled: true }, "Select an invoice option to continue");
    } else if (this.props.loads.selected) {
      button = /* @__PURE__ */ React.createElement("button", { className: "button--disabled", disabled: true }, "Select a ", Account.carrierTermLower(), " to continue");
    } else {
      button = /* @__PURE__ */ React.createElement("button", { className: "button--disabled", disabled: true }, "Select a load to continue");
    }
    const progressItems = getLoadAssignerProgressItems(
      this.props.loads.selectedLoad,
      this.props.documentBatch,
      this.props.documentGroup,
      this.invoiceDataEntered(),
      this.props.shipmentDocumentSelections,
      false,
      this.props.documentLoadRelationships
    );
    return /* @__PURE__ */ React.createElement("div", { className: bem("__actions") }, /* @__PURE__ */ React.createElement(LoadAssignerProgress, { content: button, items: progressItems }));
  },
  guessedLoadsContent: function() {
    if (!this.state.showSearch) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        LoadTable,
        {
          items: this.guessedLoads(),
          highlightChanged: this.props.highlightReference,
          selectedLoadStateId: this.props.loads.selected,
          highlightedLoads: _.pluck(this.guessedLoads(), "id"),
          loadsNotFromEmailCarrier: this.loadsNotFromEmailCarrier,
          onSelectionChange: this.props.setSelectedLoad
        }
      ));
    }
  },
  recentlyResolved: function() {
    this.setState({ recentlyResolved: true });
  },
  closeExceptions: function() {
    this.setState({ recentlyResolved: false, showExceptions: false });
  },
  reportProblemContent: function() {
    if (this.state.showExceptions || !this.state.showExceptions && this.state.recentlyResolved) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "load-assigner__document-exception-area panel",
          ref: "problemContent"
        },
        /* @__PURE__ */ React.createElement(
          DocumentExceptionArea,
          {
            closeExceptions: this.closeExceptions,
            location: this.props.location,
            recentlyResolved: this.recentlyResolved,
            hasMore: this.props.hasMore,
            documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
            model: this.props.model,
            email: this.props.email,
            carrier: this.props.carrier,
            documentGroup: this.props.documentGroup,
            exceptionResolver: this.props.exceptionResolver,
            exceptionCreator: this.props.exceptionCreator,
            exceptionUpdater: this.props.exceptionUpdater,
            exceptions: this.activeExceptions(),
            scrollUp: this.scrollUp,
            onCancel: this.toggleExceptions
          }
        )
      );
    }
  },
  possibleMultipleGuessedCarriersNotification: function() {
    if (this.props.documentGroup.multiple_guessed_carriers) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--progress" }, "TriumphPay Audit was unable to automatically assign a", " ", Account.carrierTermLower(), " to this group because multiple different", " ", Account.carrierTermLower(), "s or multiple matching", " ", Account.carrierTermLower(), "s with similar names were detected in the documents.");
    }
  },
  activeExceptions: function(givenProps) {
    const props = givenProps ? givenProps : this.props;
    return _.reject(
      props.documentGroup.exception_events,
      _.property("resolved_at")
    );
  },
  loadSearchArea: function() {
    if (this.state.showSearch) {
      return /* @__PURE__ */ React.createElement(
        LoadSearchArea,
        {
          loadsNotFromEmailCarrier: this.loadsNotFromEmailCarrier,
          carrier: this.props.carrier,
          selectedLoadStateId: this.props.loads.selected,
          highlightedLoads: _.pluck(this.guessedLoads(), "id"),
          searcher: this.props.searcher,
          onSelectionChange: this.props.setSelectedLoad,
          onCancel: this.cancelSearch,
          multiCarrier: this.props.multiCarrier,
          highlightReference: this.props.highlightReference
        }
      );
    }
  },
  scrollUp: function() {
    const container = ReactDOM.findDOMNode(this.refs.problemContent);
    container.scrollIntoView();
  },
  isIndexCustomerOnlyDocsEnabled: function() {
    return Account.currentSettings().allow_indexing_customer_only_documents && this.props.documentBatch.customer_only;
  },
  showInvoiceChooserForCustomerOnlyDocs: function() {
    return this.props.loads.selected && this.props.assignCustomerOnlyDocuments && this.isIndexCustomerOnlyDocsEnabled();
  }
});
